<template>
  <div class="managerHeader ub-ac">
    <div class="header-box ub ub-ps pad-t pad-b pad-l pad-r mar-b">
      <div class="box-l">
        <div class="ft30 ft-w pad-b">{{ managerInfo.MangerName }}</div>
        <div class="ub ub-ps">
          <div class="pad-r info-l">
            <!-- 需求7424PC端-官网公示页面，项目负责人信息公示的良好与不良；风险名单公示页面项目负责人，详情页的所属企业隐藏 -->
            <!-- <div>所属物业服务企业：{{ managerInfo.OrgName }}</div> -->
            <div v-if="type == 'base' || type == 'evaluation'">
              在管物业项目：{{ managerInfo.InChargeOfArea || 0 }} 个
            </div>
            <!-- <div>
              手机号码：{{
                managerInfo.MangerMob
                  ? managerInfo.MangerMob.replace(
                      /(\d{3})\d{4}(\d{4})/,
                      '$1****$2'
                    )
                  : ''
              }}
            </div> -->
          </div>
          <!-- <div class="pad-r info-r">
            <div>
              手机号码：{{
                managerInfo.MangerMob
                  ? managerInfo.MangerMob.replace(
                      /(\d{3})\d{4}(\d{4})/,
                      '$1****$2'
                    )
                  : ''
              }}
            </div>
          </div> -->
        </div>
      </div>
      <div class="box-r" v-if="type == 'base'">
        <div class="ub ub-ar">
          <div class="scoring-box tx-c">
            <div class="i-box">
              <svg-icon icon-class="jcxxdf" class="iconstyle"></svg-icon>
            </div>
            <div>基础信息得分</div>
            <div class="ft20 col-b ft-w">{{ scoreInfo.BasicScore }}</div>
            <div class="col-r">含基础分20分</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'managerHeader',
  props: {
    managerInfo: {
      type: Object,
      default: {},
    },
    // dataInfoObj: {
    //   type: Object,
    //   default: {},
    // },
    scoreInfo: Object,
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.managerHeader {
  .header-box {
    box-shadow: 0px 1px 3px 0px rgba($color: #000000, $alpha: 0.1);
    .box-l {
      width: 60%;
      .info-l {
        width: 64%;
        line-height: 26px;
      }
      .info-r {
        width: 36%;
        line-height: 26px;
      }
    }
    .box-r {
      width: 40%;
      border-left: 1px solid #ddd;
      .scoring-box {
        .i-box {
          vertical-align: middle;
          line-height: 40px;
          .iconstyle {
            font-size: 40px;
            margin: 0 6px;
            color: #ffb11a;
            margin-top: 10px;
            border-radius: 50%;
            background: #efefef;
          }
          img {
            border-radius: 50%;
            border: 1px solid #efefef;
            background: #efefef;
          }
        }
      }
    }
  }
}
</style>
